module.exports = __webpack_public_path__ + "why17.png?def75df1c96456961dad8d228ec80402";